import "./Experience.module.css";
import Header from "@/reusable_sections/Header";
import CustomDesignProcess from "./sections/CustomDesignProcess";
import Packages from "./sections/Packages";
import RegulatoryFaq from "./sections/RegulatoryFaq";
import Footer from "@/reusable_sections/Footer";
export default function ExperiencePage() {
  return <div>
      <Header />
      <CustomDesignProcess />
      <Packages />
      <RegulatoryFaq />
      <Footer />
    </div>;
}